<template>
  <div>
    <Navbar :navVis="navVis"></Navbar>
    <router-view></router-view>
    <Footer :navVis="navVis"></Footer>
  </div>
</template>

<script>
import Footer from './components/Footer.vue'
import Navbar from './components/Navbar.vue'

export default {
  components: {
    Footer,
    Navbar
  },
  data: function() {
    return {
      leadid: this.$route.query.leadid,
      navVis: true,
      address: null
    }
  },
  name: 'app'
}
</script>

<style lang="scss">
</style>
